export default "__VITE_ASSET__Kb9W9xr___"